import Container from '@elao/container.js';
import {
  applyMiddleware,
  createStore,
  combineReducers,
} from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import config from './config';
import ApiClient from './api/ApiClient';
import GraphQLClient from './api/GraphQLClient';
import Authenticator from './api/Authenticator';

// Reducers
import auth from './modules/auth/reducers/auth';
import services from './modules/services/reducers/services';
import selectedService from './modules/services/reducers/selectedService';
import profile from './modules/profile/reducers/profile';

const middlewares = [thunk];
const reducers = combineReducers({
  auth,
  services,
  selectedService,
  profile,
});

if (process.env.NODE_ENV === 'development') {
  const logger = createLogger({ collapsed: true });

  middlewares.push(logger);
}

const container = new Container();

// Store
container.register('store', createStore(reducers, applyMiddleware(...middlewares)));

// Parameters
container.registerParameter('api_host', config.API_HOST);
container.registerParameter('base_name', config.BASE_NAME);
container.registerParameter('utpa_email', config.UTPA_EMAIL);
container.registerParameter('utpa_phone', config.UTPA_PHONE);

// Services
container.registerDefinition('api', ApiClient, ['api_host', 'store']);
container.registerDefinition('graphql', GraphQLClient, ['api_host', 'store']);
container.registerDefinition('authenticator', Authenticator, ['api', 'graphql']);

export const get = container.get;

export default container;



// WEBPACK FOOTER //
// ./src/container.js